import React, {useContext} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {PartnerContext} from '../PartnerContexts'

const BulkAddUserModalHeader: React.FC = () => {
  const {closeBulkAddUserModal} = useContext(PartnerContext)

  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Agregar Usuarios</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeBulkAddUserModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
    </div>
  )
}

export {BulkAddUserModalHeader}
